import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  useGetOrdersQuery,
  useGetOrderQuery,
} from '../apis/mlkApi/mlk.api.hooks';
import { Order } from '../models';
import { Routes } from '../routes/types';
import { useIsNoAssign } from './useIsNoAssign';

type OrderIdRouteParam = {
  orderId: string;
};

export const useOrderDetails = () => {
  const history = useHistory();
  const { orderId } = useParams<OrderIdRouteParam>();
  const isNoAssign = useIsNoAssign();

  const [orderToSearch, setOrderToSearch] = useState<Order>();

  const { data: orders } = useGetOrdersQuery(undefined);
  const { data: order } = useGetOrderQuery(
    { orderId: orderToSearch?.opaqueId || '', isNoAssign },
    {
      skip: !orderToSearch,
    }
  );

  useEffect(() => {
    if (orderId && orders) {
      const searchedOrder = orders?.orders.find((o) => o.id === +orderId);
      if (!searchedOrder) {
        history.replace(Routes.Home);
      } else {
        setOrderToSearch(searchedOrder);
      }
    }
  }, [history, orderId, orders]);

  useEffect(() => {
    if (!orderId) {
      history.push(Routes.Home);
    }
  }, [history, orderId]);

  return order;
};
